module.exports = __webpack_public_path__ + "static/media/Error.86cfe8cd.jpg";